'use client';

import { Text, Icon, Container, useResizeObserver } from '@weareconceptstudio/core';

//* Helpers
import { config } from '@/helpers';

//* HOC's
import { withDataContext } from '@/context';

//* Components
import Button from '@/components/Button';

//* Style
import CallToActionStyle from './style';
import { useEffect, useRef } from 'react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import gsap from 'gsap/all';
import CustomImage from '@/components/Image';

const CallToAction = ({ title, description, globalData }) => {
	const fallbackTitle = title || globalData.call_to_action?.title;
	const fallbackDescription = description || globalData.call_to_action?.description;

	//! Ref
	const styleRef = useRef();
	const triggerRef = useRef();
	const iconRef = useRef();
	const buttonRef = useRef();

	const resize = useResizeObserver(document.querySelector('body'));

	useEffect(() => {
		if (styleRef.current && buttonRef.current) {
			const elements = [iconRef?.current, buttonRef.current].filter(Boolean);

			triggerRef.current = ScrollTrigger.create({
				start: 'top bottom',
				end: 'top top',
				trigger: styleRef.current,
				// markers: true,
				onEnter: () => {
					if (buttonRef.current) {
						styleRef.current?.classList?.add('active');
						gsap.to(elements, {
							opacity: 1,
							duration: 0.6,
							ease: 'power2.in',
							delay: 0.1,
							stagger: 0.15,
						});
						gsap.to(elements, {
							scale: 1,
							duration: 0.6,
							ease: 'back.out',
							delay: 0.2,
							stagger: 0.15,
						});
					}
				},
				onLeaveBack: () => {
					gsap.killTweensOf([buttonRef.current, iconRef.current]);
					gsap.set(elements, { opacity: 0, scale: 0.5 });

					styleRef.current?.classList?.remove('active');
				},
			});
		}
		return () => {
			if (triggerRef.current) {
				triggerRef.current.kill();
			}
		};
	}, [resize]);

	return (
		<CallToActionStyle ref={styleRef}>
			<div className='outside-wrapper'>
				<div className='empty-bg' />

				<Container
					full
					row
					className={'call-to-action-container'}>
					<div className={'col-2 col-dxl-3 col-t-2 col-m-12'} />
					<div className={'col-8 col-dxl-6 col-t-8 col-m-12'}>
						<div className='call-to-text-wrapper'>
							{fallbackTitle ? (
								<Text className={'h6 grotesk-500 title-other'}>{fallbackTitle}</Text>
							) : (
								<div
									ref={iconRef}
									className='wrapper-icon'>
									<Icon
										className={'icon h4'}
										name='energy'
									/>
								</div>
							)}
							{fallbackDescription && <Text className={'h2 funnel-600 desc'}>{fallbackDescription}</Text>}
							<div
								ref={buttonRef}
								className={'button-wrapper opacity-zero'}>
								<Button
									url={config.routes.contactUs.path}
									btnType={'primary'}>
									Contact us
								</Button>
							</div>
							<div className='cols-svg'>
								<div className='wrapper-svg'>
									<CustomImage src={'/images/dots.webp'} />
								</div>
							</div>
						</div>
					</div>

					<div className={'col-2 col-dxl-3 col-t-2 col-m-12'} />
				</Container>
			</div>
		</CallToActionStyle>
	);
};

export default withDataContext(CallToAction, ['globalData']);
